import { render, staticRenderFns } from "./guide-notification-placeholder.vue?vue&type=template&id=7914720a&"
import script from "./guide-notification-placeholder.vue?vue&type=script&lang=js&"
export * from "./guide-notification-placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports